import React from "react";
import { Button } from "../components/ui/button";
import { TrendingUp, Trophy } from "lucide-react";

export default function Login() {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="grain relative min-h-screen w-full overflow-hidden bg-[#0A0A0A]">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1517747614396-d21a78b850e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxkYXJrJTIwc3RhZGl1bSUyMGxpZ2h0cyUyMHNvY2NlcnxlbnwwfHx8fDE3ODQzNjk4NzR8MA&ixlib=rb-4.1.0&q=85')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/80 to-black" />

      <div className="relative z-10 mx-auto flex min-h-screen max-w-screen-2xl flex-col px-6 md:px-12">
        {/* Header */}
        <header className="flex items-center justify-between py-8">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-md bg-[#D4FF00]">
              <Trophy className="h-5 w-5 text-black" strokeWidth={2.5} />
            </div>
            <span className="font-display text-xl font-black tracking-tight text-white">
              SURE FPS
            </span>
          </div>
          <span className="hidden text-xs uppercase tracking-[0.3em] text-zinc-500 md:block">
            Planilha Esportiva Pro
          </span>
        </header>

        {/* Hero */}
        <div className="flex flex-1 items-center">
          <div className="grid w-full grid-cols-1 items-center gap-16 lg:grid-cols-2">
            <div>
              <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-[#D4FF00]/30 bg-[#D4FF00]/5 px-3 py-1">
                <span className="h-1.5 w-1.5 rounded-full bg-[#D4FF00]" />
                <span className="text-xs uppercase tracking-widest text-[#D4FF00]">
                  Freebet · Surebet · Aumentada
                </span>
              </div>
              <h1 className="font-display text-5xl font-black leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl">
                Controle cada
                <br />
                <span className="text-[#D4FF00]">entrada</span>. Cada
                <br />
                <span className="italic font-light">lucro</span>.
              </h1>
              <p className="mt-6 max-w-md text-base leading-relaxed text-zinc-400">
                Sua planilha profissional de apostas esportivas. Registre até 5 casas por
                operação, calcule lucro automaticamente e visualize seu desempenho em tempo real.
              </p>

              <div className="mt-10 space-y-3">
                <Button
                  data-testid="google-login-btn"
                  onClick={handleGoogleLogin}
                  size="lg"
                  className="group h-14 gap-3 rounded-full bg-[#D4FF00] px-8 text-base font-bold text-black hover:bg-[#c4ee00]"
                  style={{ transition: "transform 0.2s ease, background-color 0.2s ease" }}
                >
                  <svg className="h-5 w-5" viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                  </svg>
                  Entrar com Google
                </Button>
                <p className="text-xs text-zinc-500">
                  Login seguro · Sem cartão · 100% grátis para começar
                </p>
              </div>
            </div>

            {/* Right side stats mock */}
            <div className="hidden lg:block">
              <div className="relative rounded-2xl border border-white/10 bg-black/60 p-8 backdrop-blur-md">
                <div className="mb-6 flex items-center justify-between">
                  <span className="text-xs uppercase tracking-widest text-zinc-500">
                    Fev / 2026
                  </span>
                  <TrendingUp className="h-4 w-4 text-[#00FF66]" />
                </div>
                <div className="mb-2 text-sm text-zinc-400">Lucro do mês</div>
                <div className="font-mono-num text-6xl font-bold text-[#00FF66]">
                  + R$ 4.287,50
                </div>
                <div className="mt-1 text-xs text-zinc-500">
                  ROI 14.3% · 47 operações · 91% acerto
                </div>

                <div className="mt-8 grid grid-cols-3 gap-3">
                  {[
                    { label: "Freebet", value: "R$ 1.240", color: "#D4FF00" },
                    { label: "Surebet", value: "R$ 2.180", color: "#00FF66" },
                    { label: "Aumentada", value: "R$ 867", color: "#60A5FA" },
                  ].map((s) => (
                    <div
                      key={s.label}
                      className="rounded-lg border border-white/5 bg-white/[0.02] p-3"
                    >
                      <div className="text-[0.7rem] uppercase tracking-wider text-zinc-500">
                        {s.label}
                      </div>
                      <div className="font-mono-num text-sm font-semibold" style={{ color: s.color }}>
                        {s.value}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="py-6 text-xs text-zinc-600">
          © 2026 Sure FPS · Aposte com responsabilidade.
        </footer>
      </div>
    </div>
  );
}
